import {Model} from "@bryntum/schedulerpro";
import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";
import { getAging, getFormattedFileSize } from "../../other/utils/utils.jsx";
import { SwivuDocumentType } from "../../other/constants/OtherKeys.jsx";
import { User } from "./User.jsx";

export class BoardFile extends HasProjectMixin(Model) {
  static get $name() {
    return "BoardFile"
  }

  declare id: string | number;
  declare isPhantom: boolean;
  declare name: string;
  declare isAnnotated: boolean;
  declare documentId: number;
  declare url: string;
  declare fileType: string;
  declare thumbnailUrl: string;
  declare description: string;
  declare canEdit: number;
  declare canView: number;
  declare size: number | string;
  declare taskId: number;
  declare resourceId: number;
  declare clientId: number;
  declare createdAt: Date;
  declare creatorUserId: number;
  declare updatedAt: string;
  declare updaterId: number;
  declare order: number;

  static get fields() {
    return [
      { name: "name", type: "string" },
      { name: "isAnnotated", dataSource: "is_annotated", type: "boolean" },
      { name: "documentId", dataSource: "document", type: "integer" },
      { name: "url", type: "string" },
      { name: "fileType", dataSource: "file_type", type: "string" },
      { name: "thumbnailUrl", dataSource: "thumbnail_url", type: "string" },
      { name: "description", dataSource: "description", type: "string" },
      { name: "canEdit", dataSource: "can_edit_grant", type: "integer" },
      { name: "canView", dataSource: "can_view_grant", type: "integer" },
      { name: "size", dataSource: "size_bytes", type: "integer" },
      { name: "taskId", dataSource: "task", type: "integer" },
      { name: "resourceId", dataSource: "resource", type: "integer" },
      { name: "clientId", dataSource: "client", type: "integer" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "creatorUserId", dataSource: "creator", type: "integer" },
      { name: "updatedAt", dataSource: "updated_at" },
      { name: "updaterId", dataSource: "updater" },
      { name: "order", type: "integer" }
    ]
  }

  get swivuDocumentRecordMapping() {
    return {
      boardId: null,
      originalRecordId: this.id,
      source: SwivuDocumentType.swivuFile,
      name: this.name,
      addedBy: this.uploadedBy,
      canEdit: this.canEdit,
      canView: this.canView,
      aging: this.aging,
      fileType: this.fileType,
      description: this.description,
      size: this.formatFileSize,
      lastUpdatedAt: this.updatedAt,
      lastUpdatedBy: this.updatedBy,
      resourceId: this.resourceId,
      taskId: this.taskId,
      clientId: this.clientId,
      isAnnotated: this.isAnnotated,

      url: this.url,
      thumbnailImageUrl: this.thumbnailUrl,
    }
  }

  get formatFileSize() {
    return getFormattedFileSize(this.get("size"));
  }

  get uploadedBy() {
    if (this.project) {
      return this.project.boardUsersStore.find((boardUser: User) => boardUser.id === this.creatorUserId)?.name;
    }
    return null;
  }

  get updatedBy() {
    if (this.project) {
      return this.project.boardUsersStore.find((boardUser: User) => boardUser.id === this.updaterId)?.name;
    }
    return null;
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }
}

// @ts-expect-error - accessing internal properties
BoardFile.exposeProperties();
